import logo from './logo.png';
import './App.css';
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        
      </header>
      <main>
        <Dictionary defaultKeyword="Sunrise"/>
      
      </main>
      <footer className="App-footer"> 
        This site is created by Richu and  
      <a href="https://github.com/RichuGanjoo/dictionary-project" className="github link"> Source code link...</a>
      </footer>
    </div>
    </div>
  );
}


